import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { API } from "../../common/model/objectTypes";
import { deliveredInfo } from "../../utils/apiDescription/sig/delivered";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { getAccessLinkRequestParameter, getAccessLinkResponseBody, getDeliveredSignatureRequestParameter, getDeliveredSignatureResponseBody, getSignerDetailsRequestParameter, getSignerDetailsResponseBody, sendReminderRequestBody, SIG_DeliveredAPI_ResendAccessLinkRequestBody, sigBaseRequestBody } from "../../utils/sig/apiObject";
import { archiveSignatureJsonRequestCurl, deleteSignatureJsonRequestCurl, getAccessLinkJsonRequestCurl, getDeliveredSignatureJsonRequestCurl, getSignerDetailsJsonRequestCurl, resendAccessLinkJsonRequestCurl, sendReminderJsonRequestCurl } from "../../utils/sig/sampleJsonRequest";
import { getAccessLinkJsonResponse, getDeliveredSignatureJsonResponse, getSignerDetailsJsonResponse } from "../../utils/sig/sampleJsonResponse";

const archiveSignature: API = {
    name: "Archive Signature",
    url: `${API_BASE_URL}/${SIG.DELIVERED.ARCHIVE_SIGNATURE_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredInfo.archiveSignature,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveSignatureJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const deleteSignature: API = {
    name: "Delete Signature",
    url: `${API_BASE_URL}/${SIG.DELIVERED.DELETE_SIGNATURES_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredInfo.deleteSignature,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteSignatureJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const resendAccessLink: API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SIG.DELIVERED.RESEND_ACCESS_LINK_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: deliveredInfo.resendAccessLink,
    requestBody: SIG_DeliveredAPI_ResendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: resendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const sendReminder: API = {
    name: "Send Reminder",
    url: `${API_BASE_URL}/${SIG.DELIVERED.SEND_REMINDER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: deliveredInfo.sendReminder,
    requestBody: sendReminderRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendReminderJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const All: API = {
    name: "Delivered Signature",
    url: `${API_BASE_URL}/${SIG.DELIVERED.GET_DELIVERED_SIGNATURES_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredInfo.getDeliveredSignature,
    requestBody: getDeliveredSignatureRequestParameter,
    responseBody: getDeliveredSignatureResponseBody,
    jsonRequest: getDeliveredSignatureJsonRequestCurl,
    jsonResponse: getDeliveredSignatureJsonResponse,
}

const signerDetails: API = {
    name: "Signer Details",
    url: `${API_BASE_URL}/${SIG.DELIVERED.GET_SINGER_DETAIL_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredInfo.getSignerDetails,
    requestBody: getSignerDetailsRequestParameter,
    responseBody: getSignerDetailsResponseBody,
    jsonRequest: getSignerDetailsJsonRequestCurl,
    jsonResponse: getSignerDetailsJsonResponse,
}

const accessLink: API = {
    name: "Access Link",
    url: `${API_BASE_URL}/${SIG.DELIVERED.GET_ACCESS_LINK_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredInfo.getAccessLink,
    requestBody: getAccessLinkRequestParameter,
    responseBody: getAccessLinkResponseBody,
    jsonRequest: getAccessLinkJsonRequestCurl,
    jsonResponse: getAccessLinkJsonResponse,
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Archive Signature':
            return archiveSignature;
        case 'Delete Signature':
            return deleteSignature;
        case 'Resend Access Link':
            return resendAccessLink;
        case 'Send Reminder':
            return sendReminder;
        case 'Signer Details':
            return signerDetails;
        case 'Access Link':
            return accessLink;
    }
}